import { MouseEvent, useCallback } from 'react';
import { EventPanelFormType } from '@mark43/cad-api';
import { usePruneInvolvedPersonRangeValues } from '../../event-panel/event-panel-form/involved-person-vehicle-fields/persons/use-prune-involved-person-range-values';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';

export function useSubmitEventForm() {
    const { form, onSubmit } = useIntegratedForm<EventPanelFormType>();
    const { fixAllRanges } = usePruneInvolvedPersonRangeValues(form);
    const { eventPanelConfiguration } = useBootstrapState();

    return useCallback(
        (
            e?: MouseEvent<HTMLButtonElement>,
            onSuccess?: () => void,
            onError?: (error?: unknown) => void
        ) => {
            fixAllRanges();
            form.setValue(
                'eventCommunication',
                eventPanelConfiguration?.eventCommunicationSave ?? null
            );

            onSubmit(
                e,
                () => {
                    onSuccess?.();
                },
                (error) => {
                    onError?.(error);
                }
            );
        },
        [eventPanelConfiguration, fixAllRanges, form, onSubmit]
    );
}
